import cookies from 'browser-cookies';
import get from 'lodash/get';

import store from '../app/store';
import { isPublicRoute } from './helpers';
import { logOutIntercom, appLogout } from './utils';
import { purgeAccountData, clearToken } from '../redux/actions/accountActions';
import { clearAdmin } from '../redux/actions/adminActions';
import { showNormalNotification } from '../redux/actions/notificationsActions';
import {
  clearAuthMethodCache,
  shouldUseKeycloakLogout,
  isUsingKeycloakAuth
} from '../components/auth/keycloakUtils';

export function handle401() {
  if (isPublicRoute()) return;

  const { status } = get(store.getState(), 'admin', {});
  if (status === 'active') store.dispatch(clearAdmin());

  logOutIntercom();
  cookies.set('prevpath', window.location.pathname);
  clearAuthMethodCache();

  if (isUsingKeycloakAuth() && shouldUseKeycloakLogout()) {
    store.dispatch(showNormalNotification({ color: 'warning', message: 'Tu sesión expiró.', duration: 3 }));
    appLogout();
  } else {
    store.dispatch(showNormalNotification({ color: 'warning', message: 'Tu sesión expiró.', duration: 5, unique: true }));
    store.dispatch(purgeAccountData());
    store.dispatch(clearToken({ redirect: '/' }));
  }
}

export function applyAuth401Handler(axiosInstance) {
  axiosInstance.interceptors.response.use(
    res => res,
    error => {
      if (get(error, 'response.status') === 401) handle401();
      return Promise.reject(error);
    }
  );
  return axiosInstance;
}



// WEBPACK FOOTER //
// ./src/libs/handle401.js